import { takeLatest } from "redux-saga/effects";
import { GetRefundHistory } from "../../StateManagement/Reducers/RefundState";
import { RefundListApi } from "./RefundSagaWorkers";

export function* RefundListWatcher() {
  console.log("reached Refund watcher");

  yield takeLatest(GetRefundHistory.type, RefundListApi);
}

export default RefundListWatcher;
